export default __webpack_public_path__ + "static/media/July_09.e4dc50e6.png";